import React, { useEffect, useRef , useState } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {Modal, Button, Form} from "react-bootstrap";
import './details.css';
import SyllabusAccordion from '../../components/accordian/accordian';
import InstructorProfile from '../../components/profileCard/profileCard';
import StatsBanner from '../../components/stats/stats';
import CourseCard from '../../components/courseCard/courseCard';
import TestimonialsSection from '../../components/testimonials/descriptionTestimonial';
import OndemandVideoRoundedIcon from '@mui/icons-material/OndemandVideoRounded';
import SignalCellularAltRoundedIcon from '@mui/icons-material/SignalCellularAltRounded';
import TestimonialsGrid from "../../components/testimonials/testimonials";
import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterRounded';
import GTranslateRoundedIcon from '@mui/icons-material/GTranslateRounded';
import ContactSupportRoundedIcon from '@mui/icons-material/ContactSupportRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import FilePresentRoundedIcon from '@mui/icons-material/FilePresentRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import CloudDownloadRoundedIcon from '@mui/icons-material/CloudDownloadRounded';
import { getCourseData, addCourseToCart, updateCart } from "../../api/course";
import { useGlobalContext } from "../../context/globalContext";
import { getContent } from "../../api/content";
import { Toast } from 'bootstrap'; 
import { createBookDemoLead } from '../../api/utils';
import FeaturesScroll from "../../components/featureScroll/featureScroll";
import BookDemoForm from "../demo/bookDemo";

const Detail = (props) => {
    const location = useLocation();
    const { course_data } = location.state || {};
    const { id } = useParams(); 
    const [loadingData, setLoadingData] = useState(true);
		const [content, setContent] = useState([])
    const [courses, setCourses] = useState([]);
    const [cartData, setCartData] = useState();
    const [courseData, setCourseData] = useState(location.state?.course_data || null);
    const navigate = useNavigate();
    const { cartCourseId, handleCartAdd } = useGlobalContext();
		const [show, setShow] = useState(false);
		const toastRef = useRef(null);
  
  // State to store form input values
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: ''
  });

  useEffect(() => {
    const fetchCourseAndRecommendations = async () => {
        try {
            let course;

            if (!courseData && courseData.length == 0 && id) {
                const response = await getCourseData('single', id);
                // console.log('response: ',response)
                if (response.status) {
                    course = response.data;
                    setCourseData(course);
                } else {
                    console.error("Failed to fetch course data");
                    return;
                }
            } else {
                course = courseData;

            }

            const recommendData = await getCourseData('recommend', id);
            if (recommendData.status) {
                setCourses(recommendData.data);
            }

            setLoadingData(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    fetchCourseAndRecommendations();
}, []);

useEffect(() => {
  if (!loadingData && window.location.hash) {
    const id = window.location.hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
}, [loadingData]);


		const handleClose = () => setShow(false);
		const handleShow = () => setShow(true);
	
    const handlePurchaseClick = async () => {
        let courseData = {
            "id": course_data.id,
            "name": course_data.name,
            "price": course_data.price
        }
				handleCartAdd(course_data.id);
				let returnData;
				if(cartCourseId.length > 0) {
					returnData = await updateCart(courseData);
				} else {
					returnData = await addCourseToCart(courseData);
				}
        setCartData(returnData); 
    };

		const handleInputChange = (e) => {
			const { name, value } = e.target;
			setFormData({
				...formData,
				[name]: value
			});
		};

    const handleViewCartClick = () => {
        navigate("/checkout");
    };

		const handleSubmit = async (e) => {
			e.preventDefault();
			const { name, email, phone } = formData;
			if (!name || !email || !phone) {
				alert('Please fill in all fields before submitting.');
				return;
			}
			formData['course'] = course_data.name;
			formData['stage'] = 'course_detail'
			const response = await createBookDemoLead(formData);
			if (response.status === true && toastRef.current) {
				const toast = new Toast(toastRef.current);
				toast.show();
			}
			handleClose();
		};

    const isInCart = cartCourseId.some(
        (course) => course === course_data.id
    );

    return loadingData == true || courseData == null || courseData == undefined || course_data == null || course_data == undefined  ? (
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    ) : (
      <>
        <div className="detail-top-container">
          <div className="row">
            <div className="col-6 text-left d-flex flex-column justify-content-center">
              <span className="head-text h1 m-10 text-grey">
                {course_data.name}<br/>
              </span>
              <span className="h3 text-grey">
                {course_data.sub_text}
              </span>
							<br /> 
							<span className="text-secondary-main head-text h3">{course_data.subject}</span>
              <div className="head-description text-darkGrey h6">
                {course_data.description}
              </div>
              <div className="container-button">
                <button
                  className="primary-button btn btn-primary btn-lg custom-shadow top-banner-button"
                  onClick={isInCart ? handleViewCartClick : handleShow}
                >
                  Enquire Now
                  {/* {isInCart ? (
                                    <>View Cart</>
                                ) : (
                                    <>
                                    Enroll Now{" "}
                                    <small>
                                        @ <s>₹{course_data.strike_through_price}</s> ₹{course_data.price}
                                    </small>
                                    </>
                                )} */}
                </button>
              </div>
            </div>
            {/* <div className="col-1"></div> */}
            <div className="col-6 course-top-banner-image-container"></div>
          </div>
        </div>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Request A Callback</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              {/* Name Input */}
              <Form.Group controlId="formName" className="mb-2">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="John Doe"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              {/* Phone Input */}
              <Form.Group controlId="formPhone" className="mb-2">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter your phone number with Country Code"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              {/* Email Input */}
              <Form.Group controlId="formEmail" className="mb-4">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Johndoe@example.com"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Button
                className="primary-button"
                variant="primary"
                type="submit"
              >
                Submit
              </Button>
            </Form>
          </Modal.Body>
          {/* <Modal.Footer>
								<Button variant="secondary" onClick={handleClose}>
									Close
								</Button>
							</Modal.Footer> */}
        </Modal>
        <div>
          <StatsBanner data={course_data.stats}/>
        </div>
        <div className="mt-6 container">
          {/* Navigation with #anchors */}
          <div className="d-flex gap-4 border-bottom pb-3 mb-4">
            <a 
              className="text-decoration-none rounded-4 active-tab">
              About the Course
            </a>
            {course_data.course_type == undefined || course_data.course_type != 2 ?
              <a  className="text-dark text-decoration-none pd-1">
              What’s Included
              </a>:<></>
            }
            {course_data.course_type == undefined || course_data.course_type != 2 ?
              <a className="text-dark text-decoration-none pd-1">
              Syllabus
              </a>:<></>
            }
            {course_data.course_type == undefined || course_data.course_type != 2 ?
              <a className="text-dark text-decoration-none pd-1">
                Instructor
              </a>:<></>
            }
            <a
              className="text-dark text-decoration-none pd-1">
              Testimonials
            </a>
            <a
              className="text-dark text-decoration-none pd-1"
            >
              Recommendations
            </a>
          </div>

          <div id="about" className="mb-5">
            <div className="mx-5 my-5 text-center">
              <h2 className="fw-bold text-grey">About the Course</h2>
              {/* <button
                className="btn btn-outline-primary primary-button text-white d-flex align-items-center gap-2"
                onClick={() => {
                  navigator.clipboard.writeText(window.location.href)
                    .then(() => {
                      alert("Course link copied to clipboard!");
                    })
                    .catch(err => {
                      alert("Failed to copy the link. Please try again.");
                      console.error(err);
                    });
                }}
              >
                Share this Course
              </button> */}
            </div>
            <span className="mt-3 text-muted text-center col-8">
							{course_data.description}
            </span>
          </div>
          {course_data.course_type == undefined || course_data.course_type != 2 ?
            <div id="included">
            <span className="text-center"><h2 className="fw-bold text-grey">What’s Included</h2></span>
            <div className="row mt-4">
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="ter-color">
                    {" "}
                    <SignalCellularAltRoundedIcon className="mr-half" />{" "}
                    {course_data.inclusions[0]}
                  </li>
                  <li className="ter-color">
                    {" "}
                    <WatchLaterRoundedIcon className="mr-half" /> {course_data.inclusions[1]}
                  </li>
                  <li className="ter-color">
                    {" "}
                    <GTranslateRoundedIcon className="mr-half" /> {course_data.inclusions[2]}
                  </li>
                  <li className="ter-color">
                    {" "}
                    <PendingActionsRoundedIcon className="mr-half" /> {course_data.inclusions[3]}
                  </li>
                  <li className="ter-color">
                    {" "}
                    <PendingActionsRoundedIcon className="mr-half" /> {course_data.inclusions[4]}
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="ter-color">
                    {" "}
                    <FilePresentRoundedIcon className="mr-half" /> {course_data.inclusions[5]}
                  </li>
                  <li className="ter-color">
                    {" "}
                    <OndemandVideoRoundedIcon className="mr-half" /> {course_data.inclusions[6]}
                  </li>
                  <li className="ter-color">
                    {" "}
                    <MenuBookRoundedIcon className="mr-half" /> {course_data.inclusions[7]}
                  </li>
                  <li className="ter-color">
                    <PhoneIphoneRoundedIcon className="mr-half" /> {course_data.inclusions[8]}
                  </li>
                  <li className="ter-color">
                    {" "}
                    <CloudDownloadRoundedIcon className="mr-half" /> {course_data.inclusions[9]}
                  </li>
                </ul>
              </div>
            </div>
            </div>:
            <></> 
            }
          
        </div>
        {
          course_data.course_type != undefined || course_data.course_type == 2?
          <div className="container my-5">
            <span className="text-center">
            <h2 className="text-center text-grey mb-4 mt-4">
              <strong>What you get with our <span className="text-warning fw-bold">SAT</span> coaching programs</strong>
            </h2>
            </span>
            
            <FeaturesScroll />
          </div>:
          <></>
        }
        {course_data.course_type == undefined || course_data.course_type != 2 ?
          <div id="syllabus" className="container my-5">
            <SyllabusAccordion data={course_data.id}/>
          </div>: 
          <></>
        }

        {course_data.course_type == undefined || course_data.course_type != 2 ?
          <div id="instructor" className="container my-5">
            <InstructorProfile data={course_data.id}/>
          </div>: 
          <></>
        }
        {course_data.course_type == undefined || course_data.course_type != 2 ?
          <div id="testimonials" className="container h-auto mt-6">
            <TestimonialsSection />
          </div>: 
          <div className="container testimonial-container d-flex flex-column align-items-center my-5">
            <div className="row mb-5">
                <span className="text-center text-grey h1 text-bold">What Our</span><br/>
                <span className="text-center text-secondary-main h2">Students Say</span>
            </div>
            <div className="row row-cols-1 row-cols-md-3 g-5">
                <TestimonialsGrid />
            </div>
          </div>
        }
        <div
          id="recommendations"
          className="course-container-home container mt-4 mb-4"
        >
          <div className="row mb-5">
            <span className="head-text h1 m-10">Recommended Courses</span>
          </div>
          <div className="row row-cols-1 row-cols-md-3 g-5">
            <CourseCard data={courses} />
          </div>
          {/* <div className="row mt-5">
                    <div className="col text-center">
                        <button className="primary-button btn btn-primary custom-shadow" type="button">
                            Explore All Courses <KeyboardArrowRightRoundedIcon />
                        </button>
                    </div>
                </div> */}
        </div>
        {course_data.course_type != undefined || course_data.course_type == 2 ?
          <div className="demo-container" id="demo">
            <div className="container d-flex flex-column mt-5">
                <div className="row">
                    <BookDemoForm/>
                </div>
            </div>
          </div>:<></>
        }
        <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
          <div
            ref={toastRef}
            className="toast align-items-center text-bg-success border-0"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="d-flex">
              <div className="toast-body">Sit Tight! Someone from Our team will call you Soon.</div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
      </>
    );

}

export default Detail;